// NPM Modules
import React from 'react';
// Components
import MarkdownDocument from '.';
// Documents
import terms_of_service from '../../../documents/terms_of_service.md';
// Component
export default () => <MarkdownDocument source={terms_of_service} />;
